import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    map: Object
  }

  connect() {
    // console.log("on_event: connect")

    this.handler = this.handleEvent.bind(this)

    const map = this.mapValue || {}
    Object.keys(map).forEach(eventName => {
      // console.log(`on_event: listening for ${eventName}`)
      document.addEventListener(eventName, this.handler)
    })
  }

  disconnect() {
    Object.keys(this.mapValue).forEach(eventName => {
      document.removeEventListener(eventName, this.handler)
    })
  }

  handleEvent(event) {
    const urlTemplate = this.mapValue[event.type]
    if (!urlTemplate) return

    this.refresh(urlTemplate, event)
  }

  camelToSnake(str) {
    return str
      .replace(/::/g, "/")
      .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
      .toLowerCase()
  }

  async refresh(urlTemplate, event) {
    const url = new URL(urlTemplate, window.location.origin)

    // append all event.detail as query params
    if (event?.detail) {
      Object.entries(event.detail).forEach(([key, value]) => {
        const paramKey = this.camelToSnake(key)
        // console.log(`on_event: adding event detail to query params: ${paramKey}=${value}`)
        url.searchParams.set(paramKey, value)
      })
    }

    // console.log(`on_event: handling ${event.type}: fetching ${url.toString()}`)

    const response = await fetch(url.toString(), {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })

    Turbo.renderStreamMessage(await response.text())
  }
}